import { Component, OnInit, Input } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { OpAdminProductListService } from "src/app/views/common/services/op-admin-product-list.service";
import { ActivatedRoute } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { environment } from "./../../../../../environments/environment";
// import { DomSanitizer } from '@angular/platform-browser';
@Component({
  selector: "app-light-box-dialog",
  templateUrl: "./light-box-dialog.component.html",
  styleUrls: ["./light-box-dialog.component.css"],
})
export class LightBoxDialogComponent implements OnInit {
  productDetail: any = [];
  LightBoxImage: any = [];
  selectedImage = localStorage.getItem("currentSelectedImage");
  homeProductId = localStorage.getItem("productId");

  productImages = [];
  @Input() title: string;
  @Input() message: string;
  @Input() btnOkText: string;
  @Input() btnCancelText: string;
  @Input() productId: string;
  @Input() storeType: string;

  is360 = false;
  isZoomImage = true;
  isVideoUrl = false;
  currentId: any = 0;
  constructor(
    private activeModal: NgbActiveModal,
    public _sanitize: DomSanitizer,
    private sanitizer: DomSanitizer,
    private activeRoute: ActivatedRoute,
    private productListService: OpAdminProductListService,
    public _DomSanitizationService: DomSanitizer
  ) {}

  onPrevious() {
    this.currentId = this.currentId - 1;
    this.selectedImage = this.productImages[this.currentId];
    this.homeProductId = this.productImages[this.currentId];
  }
  onNext() {
    this.currentId = this.currentId + 1;
    this.selectedImage = this.productImages[this.currentId];
  }

  ngOnInit() {
    // this.activeRoute.queryParams.subscribe((params) => {
    //   let queryParams = params;
    //   this.productId = queryParams.id;
    this.productListService
      .getImagesByProduct(
        this.productId,
        this.storeType,
        this.is360,
        this.isZoomImage,
        this.isVideoUrl
      )
      .subscribe(
        (response: any) => {
          response.data.forEach((item) => {
            this.productImages.push(item);
          });
          this.selectedImage = this.productImages[0];
          this.currentId = this.productImages.indexOf(this.selectedImage);
        },
        (err: any) => {
          console.error(err);
        }
      );
    // });
  }
  public decline() {
    this.activeModal.close(false);
  }

  public accept() {
    this.activeModal.close(true);
  }

  public dismiss() {
    this.activeModal.dismiss();
  }
}
